import { Pipe, PipeTransform } from '@angular/core';
import { RouteStateEnum } from '@cue/data';
import { PathInfoResultEnum, PathResultCrate, StartTargetResultEnum } from '@cue/navigation-services';
import { translation } from '@cue/translations';

@Pipe({
  name: 'routeSearchResult',
  standalone: true,
})
export class RouteSearchResultPipe implements PipeTransform {
  protected translation = translation;

  transform(result: PathResultCrate, routeFindStatus?: RouteStateEnum): string {
    if (result != null) {
      if (routeFindStatus != null && routeFindStatus === RouteStateEnum.StartNotFound) {
        return translation.wayfinding.startNotFound;
      }

      if (result.target === StartTargetResultEnum.NotFound && result.start === StartTargetResultEnum.NotFound) {
        return translation.wayfinding.startAndTargetNotFound;
      }
      if (result.target == StartTargetResultEnum.NotFound) {
        return translation.wayfinding.targetNotFound;
      }
      if (result.start == StartTargetResultEnum.NotFound) {
        return translation.wayfinding.startNotFound;
      }
      if (result.path == PathInfoResultEnum.FoundOnlyNotBarrierPath) {
        return translation.wayfinding.barrierFreenotFound;
      }
      if (
        result.path == PathInfoResultEnum.PathNotFound &&
        result.start != StartTargetResultEnum.NotRequested &&
        result.target != StartTargetResultEnum.NotRequested
      ) {
        return translation.wayfinding.notFound;
      }
      if (
        result.path == PathInfoResultEnum.SameStartAsTarget &&
        result.start != StartTargetResultEnum.NotRequested &&
        result.target != StartTargetResultEnum.NotRequested
      ) {
        return translation.wayfinding.sameStartAsTarget;
      }
    }
    return '';
  }
}
